export class UtilsString {
  public static Empty: string = "";

  public static booleanToString(value: boolean): string {
    return value ? "Sí" : "No";
  }

  public static StringToboolean(value: string): boolean {
    if (this.ValueOf(value) === "True" || this.ValueOf(value) === "true") {
      return true;
    } else {
      return false;
    }
  }

  public static IsNullOrWhiteSpace(value: string | null): boolean {
    try {
      if (value == null || value === "undefined") {
        return true;
      }

      return value.toString().replace(/\s/g, "").length < 1;
    } catch (e) {
      return false;
    }
  }
  public static ValueOf(value: any): string {
    if (value === null || value === undefined) {
      return "";
    }
    return value.toString();
  }
  public static FormatCamelCase(value: string): string {
    let result = value.replace(/([A-Z]+)/g, " $1");
    if (result.indexOf(" ") === 0) {
      result = result.substring(1, result.length);
    }
    return result;
  }

  public static SplitComaToBr(value: string): string {
    const result = value.replace(/(,+)/g, "<br/>");
    return result;
  }

  public static cleanCharacter(value: string, char: string): string {
    if (value == null) {
      return value;
    }
    if (value.indexOf(char) === -1) {
      return value;
    } else {
      value = value.replace(char, "");
      return UtilsString.cleanCharacter(value, char);
    }
  }

  public static countChar(value: string, char: string): number {
    return (value.match(new RegExp(char, "g")) || []).length;
  }

  public static Format(format: any, ...args: any): string {
    try {
      return format
        .toString()
        .replace(/{(\d+(:\w*)?)}/g, (match: any, i: any) => {
          const s = match.split(":");
          if (s.length > 1) {
            i = i[0];
            match = s[1].replace("}", "");
          }

          const arg = UtilsString.parsePattern(match, args[i]);
          return typeof arg !== "undefined" && arg != null
            ? arg
            : UtilsString.Empty;
        });
    } catch (e) {
      return UtilsString.Empty;
    }
  }

  private static parsePattern(match: any, arg: any): string {
    if (arg == null || arg === undefined) {
      return arg;
    }

    switch (match) {
      case "L":
        arg = arg.toLowerCase();
        break;
      case "U":
        arg = arg.toUpperCase();
        break;
      case "d":
        {
          const splitted = arg.split("-");
          if (splitted.length <= 1) {
            return arg;
          }

          let day = splitted[splitted.length - 1];
          const month = splitted[splitted.length - 2];
          const year = splitted[splitted.length - 3];
          day = day.split("T")[0];
          day = day.split(" ")[0];

          arg = day + "." + month + "." + year;
        }
        break;
      case "s":
        {
          const splitted = arg.replace(",", "").split(".");
          if (splitted.length <= 1) {
            return arg;
          }

          let time = splitted[splitted.length - 1].split(" ");
          if (time.length > 1) {
            time = time[time.length - 1];
          }

          const year = splitted[splitted.length - 1].split(" ")[0];
          const month = splitted[splitted.length - 2];
          const day = splitted[splitted.length - 3];

          arg = year + "-" + month + "-" + day;
          if (time.length > 1) {
            arg += "T" + time;
          } else {
            arg += "T" + "00:00:00";
          }
        }
        break;

      case "n":
        if (isNaN(parseInt(arg, 10)) || arg.length <= 3) {
          break;
        }

        arg = arg.toString();
        const mod = arg.length % 3;
        let output = mod > 0 ? arg.substring(0, mod) : UtilsString.Empty;
        for (let i = 0; i < Math.floor(arg.length / 3); i++) {
          if (mod === 0 && i === 0) {
            output += arg.substring(mod + 3 * i, mod + 3 * i + 3);
          } else {
            output += "." + arg.substring(mod + 3 * i, mod + 3 * i + 3);
          }
        }
        arg = output;
        break;
      default:
        break;
    }

    return arg;
  }
  public static mergeclasses(claseBase: any, ...args: any[]) {
    for (let entry of args) {
      claseBase = this.merge(claseBase, entry);
    }
    return claseBase;
  }
  public static merge<A, B>(a: A, b: B): A | B {
    return Object.assign({}, a, b);
  }
  // Elimina los diacríticos de un texto excepto si es una "ñ" (ES6)
  //
  public static eliminarDiacriticosEs(texto: string) {
    texto = this.ValueOf(texto);
    texto = texto
      .normalize("NFD")
      .replace(
        /([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,
        "$1"
      )
      .normalize();
    texto = texto.replace("-", "").replace("_", "");
    return texto;
  }
  public static cortarStringLargo(str: string, maxLenght: number) {
    if (str.length > maxLenght) str = str.substring(0, maxLenght);
    return str;
  }
  public static IsValidParamUrl(param: any) {
    return !UtilsString.IsNullOrWhiteSpace(UtilsString.ValueOf(param));
  }

  public static ValueOfValue(value: any): any {
    if (value === null || value === undefined) {
      return "";
    }
    if (this.IsNullOrWhiteSpace(value)) {
      return "";
    }
    return value;
  }
  public static ValueOfValueName(object: any, name_variable: string): any {
    let valor = "";
    try {
      valor = eval("object." + name_variable + "");
    } catch (error) {}
    return this.ValueOfValue(valor);
  }

  public static FristLetterMayu(string: string) {
    string = this.ValueOfValue(string);
    if (this.IsNullOrWhiteSpace(string)) {
      return "";
    }
    string =
      string.slice(0, 1).toUpperCase() +
      string.slice(1, string.length).toLowerCase();
    return string;
  }

  public static IsEmptyTextPutThis(dato_comprare: string, texto: string) {
    dato_comprare = UtilsString.ValueOf(dato_comprare);
    if (UtilsString.IsNullOrWhiteSpace(dato_comprare)) {
      return texto;
    }
    return dato_comprare;
  }
}
